import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckCircle2, Clock } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide15Timeline({
  index
}: SlideProps) {
  const timeline = ['Scope confirmation', 'Master concept and structure', 'French production', 'Internal review', 'Ministry review', 'Campaign launch', 'Monthly optimization'];
  return <InteriorSlide data-id="element-305">
      <SlideHeader eyebrow="Timeline & Approval Considerations" data-id="element-306">
        Scope finalization should begin immediately
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-307">
        {/* Left: Considerations */}
        <div className="flex-1 space-y-6" data-id="element-308">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="bg-[var(--surface)] p-6 rounded-2xl border border-black/5" data-id="element-309">
            <h3 className="text-lg font-bold text-[var(--fg)] mb-4 flex items-center gap-2" data-id="element-310">
              <AlertTriangle className="h-5 w-5 text-[var(--brand)]" data-id="element-311" />
              Approval Considerations
            </h3>
            <ul className="space-y-4" data-id="element-312">
              {['Use of pre-approved Roche assets where possible', 'Internal Roche MLR review', 'Local Ministry of Health reviews where applicable', 'Expected review times per country', 'Localization and translation timelines', 'MSA finalization and vendor onboarding'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-313">
                  <div className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[var(--brand)] flex-shrink-0" data-id="element-314" />
                  <span className="text-[var(--muted)] leading-snug" data-id="element-315">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Right: Gantt Timeline */}
        <div className="flex-[1.5] w-full" data-id="element-316">
          <motion.h3 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="text-lg font-bold text-[var(--fg)] mb-6" data-id="element-317">
            Suggested Timeline
          </motion.h3>

          <div className="bg-white rounded-2xl shadow-sm border border-black/5 p-6 relative overflow-hidden" data-id="element-318">
            {/* Vertical grid lines */}
            <div className="absolute top-0 bottom-0 left-1/3 w-px bg-black/5" data-id="element-319" />
            <div className="absolute top-0 bottom-0 left-1/2 w-px bg-black/5" data-id="element-320" />
            <div className="absolute top-0 bottom-0 left-[66%] w-px bg-black/5" data-id="element-321" />
            <div className="absolute top-0 bottom-0 left-[83%] w-px bg-black/5" data-id="element-322" />

            <div className="space-y-4 relative z-10" data-id="element-323">
              {timeline.map((step, i) => {
              // Calculate width and margin based on index to simulate Gantt
              const width = i === 4 ? 'w-1/3' : i === 6 ? 'w-1/4' : 'w-1/4';
              const ml = i === 0 ? 'ml-0' : i === 1 ? 'ml-[10%]' : i === 2 ? 'ml-[25%]' : i === 3 ? 'ml-[35%]' : i === 4 ? 'ml-[45%]' : i === 5 ? 'ml-[75%]' : 'ml-[80%]';
              const color = i === 4 ? 'bg-[var(--brand-lighter)] text-[var(--brand)]' : i === 5 ? 'bg-[var(--brand)] text-white' : 'bg-[var(--surface)] text-[var(--fg)]';
              return <motion.div key={step} initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 0.5 + i * 0.1,
                duration: 0.5
              }} className="flex items-center gap-4" data-id="element-324">
                    <div className="w-1/3 text-sm font-semibold text-[var(--fg)] text-right pr-4" data-id="element-325">
                      {step}
                    </div>
                    <div className="flex-1" data-id="element-326">
                      <div className={`h-8 rounded-md flex items-center px-3 text-xs font-bold shadow-sm ${width} ${ml} ${color}`} data-id="element-327">
                        {i === 4 && <Clock className="h-3 w-3 mr-1.5" data-id="element-328" />}
                        {i === 5 && <CheckCircle2 className="h-3 w-3 mr-1.5" data-id="element-329" />}
                      </div>
                    </div>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </InteriorSlide>;
}